import {
  afterNextRender,
  Directive,
  DOCUMENT,
  EventEmitter,
  HostListener,
  inject,
  Input,
  Output,
  PLATFORM_ID,
  signal,
  WritableSignal
} from '@angular/core';
import {gsap} from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
import {isPlatformBrowser} from '@angular/common';
import {navigatorScrollingSignal} from '../signal/common/navigator-scrolling.signal';

@Directive({
  selector: '[navigator]'
})
export class NavigatorDirective {

  @Input('navigator') targetId!: string | undefined;
  @Input() navigatorDuration: number = 1.5;
  @Input() navigatorOffset: number = 0;
  @Input() navigatorEasing: gsap.EaseString = 'power3.out';
  @Output() navigatorEmitter = new EventEmitter<void>();
  private readonly document = inject(DOCUMENT);
  private readonly platformId = inject(PLATFORM_ID);
  protected readonly isBrowser = isPlatformBrowser(this.platformId)

  constructor() {
    afterNextRender(() => {
      gsap.registerPlugin(ScrollToPlugin);
    })
  }

  @HostListener('click')
  onClick() {
    if (!this.isBrowser) return;

    if (!this.targetId) {
      console.error(`Target element with id "${this.targetId}" not found.`);
      return;
    }

    const target = this.document.getElementById(this.targetId);

    if (!target) {
      console.error(`Target element: "${target}" not found.`);
      return;
    }

    this.navigatorEmitter.emit();

    const top = target.getBoundingClientRect().top + window.scrollY;

    navigatorScrollingSignal.set(true);
    gsap.to(window, {
      duration: this.navigatorDuration,
      scrollTo: {y: this.navigatorOffset + top},
      ease: this.navigatorEasing,
      onComplete: () => navigatorScrollingSignal.set(false)
    });
  }
}
